export const Constant = {
  DEFAULT_DURATION_IN_MS: 200,
  DEFAULT_DELAY_IN_MS: 0,

  MIN_TRANSLATE_Y: -50,
  MAX_TRANSLATE_Y: 50,
  INITIAL_TRANSLATE_Y: 0,

  DAMPING: 2,
  REST_SPEED_THRESHOLD: 0.1,

  // វាដូចជារូស័រ បើសិន stiffness ច្រើនរូស័រមិនអាចទាញបានឆ្ងាយទេ
  STIFFNESS: 2000,
  VELOCITY: 500,
};
